<template>
  <div class="guides">
    <div class="guides-list">
      <div class="guides-list-item-head">
        <el-button type="primary" size="small" @click="addItemHandler()"
          >Добавить</el-button
        >
      </div>
      <div class="guides-references-list">
        <reference-item
          v-for="item of referencesList.items"
          :key="item.id"
          :reference-item="item"
          :active-edit-item-id="activeEditItemId"
          @onEditItem="editItemHandler"
          @onDeleteItem="deleteItemHandler"
          @onCancelEditItem="cancelEditItemHandler"
          @onAddFile="addFileHandler"
          @onRemoveFile="removeFileHandler"
        />
      </div>
    </div>

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()"
          >Сохранить</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="400px"
      title="Добавление файла"
      :visible.sync="showAddFileModal"
    >
      <el-form
        :model="addFileForm"
        ref="addFileForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item prop="file">
          <div class="files-upload-list">
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action=""
              :http-request="uploadFile"
              :file-list="addFileForm.newFiles"
              :multiple="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $t("feed.settings.common.commonSimpleForm.upload[0]") }}
                <em>{{
                  $t("feed.settings.common.commonSimpleForm.upload[1]")
                }}</em>
              </div>
            </el-upload>

            <ul class="files-list" v-if="addFileForm.files.length">
              <li class="files-list__item-title">
                {{ $t("feed.settings.common.commonSimpleForm.uploaded") }}:
              </li>
              <li
                class="files-list__item"
                v-for="file in addFileForm.files"
                :key="file.link"
              >
                <span class="files-list__item-name">
                  {{ file.filename }}
                </span>
                <el-link
                  type="primary"
                  icon="el-icon-download"
                  :href="file.link"
                  :underline="false"
                  >{{
                    $t("feed.settings.common.commonSimpleForm.download")
                  }}</el-link
                >
              </li>
            </ul>
          </div>
        </el-form-item>
        <!--        <el-button type="primary" @click="submitForm()">Отправить</el-button>-->
        <!--        <el-button type="primary" @click="resetForm('addFileForm')">Отменить</el-button>-->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// components
import ReferenceItem from "./ReferenceItem.vue";

// api
import {
  getReferencesApi,
  getReferenceAddItemApi,
  getAddThematicApi,
  getRemoveThematicApi,
  getReferenceRemoveItemApi,
  getThematicListApi,
} from "../../../../api/references";

// vuex
import { mapGetters } from "vuex";
import {
  referenceAddFileApi,
  referenceRemoveFileApi,
} from "../../../../api/files";
import notify from "../../../../helpers/notify";

export default {
  name: "Themes",
  data() {
    return {
      group: "",
      referencesList: [],
      currentReferenceId: null,
      createDialogVisible: false,
      newReferenceName: "",
      newReferenceKeyword: "",
      newReferenceKeywordList: [],
      activeEditItemId: null,
      addFileForm: {
        files: [],
      },
      showAddFileModal: false,
      addFileReferenceItemId: null,
      roles: this.$t("user.roles"),
    };
  },
  computed: {
    ...mapGetters(["users", "isAdmin"]),
  },
  methods: {
    getRole(role) {
      return this.roles.find((item) => item.name === role).title;
    },
    loadReferences() {
      {
        const params = {
          group_id: parseInt(this.group),
        };
        getThematicListApi({}).then((resp) => {
          this.referencesList = resp.data;
        });
      }
    },
    addItemHandler() {
      this.createDialogVisible = true;
    },
    editItemHandler(id) {
      this.activeEditItemId = id;
    },
    cancelEditItemHandler() {
      this.activeEditItemId = null;
    },
    deleteItemHandler(id) {
      getRemoveThematicApi({ id }).then(() => {
        this.loadReferences();
      });
    },
    addFileHandler(id) {
      this.addFileReferenceItemId = id;
      this.showAddFileModal = true;
    },
    uploadFile(file) {
      console.log("uploadFile", file);
      let fd = new FormData();
      fd.append("upfile", file.file, file.file.name);
      fd.append("reference_item_id", String(this.addFileReferenceItemId));

      referenceAddFileApi(fd)
        .then(() => {
          notify.call(this, `Файл ${file.file.name} загружен`, "success");
        })
        .catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        })
        .finally(() => {
          this.$refs.upload.clearFiles();
          this.showAddFileModal = false;
          this.loadReferences();
        });
    },
    removeFileHandler(id) {
      const params = {
        reference_item_id: id,
      };

      referenceRemoveFileApi(params)
        .then(() => {
          notify.call(this, `Файл удален`, "success");
        })
        .catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        })
        .finally(() => {
          this.loadReferences();
        });
    },
    saveReferencesItem() {
      if (this.newReferenceName === "") {
        return;
      }

      const params = {
        title: this.newReferenceName,
      };
      getAddThematicApi(params).then(() => {
        this.currentReferenceId = null;
        this.newReferenceName = "";
        this.createDialogVisible = false;
        this.loadReferences();
      });
    },
  },
  components: {
    ReferenceItem,
  },
  beforeMount() {
    this.loadReferences();
  },
};
</script>

<style>
.guides-head {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.guides-list {
}
.guides-list-item:not(:last-child) {
  margin-bottom: 40px;
}
.guides-list-item-head {
  display: flex;
  align-items: center;
  margin: 0 0 15px;
}
.guides-list-item-head .el-button--small,
.el-button--small.is-round {
  padding: 4px 15px;
}
.guides-list-item-title {
  margin: 0 20px 0 0;
}
.guides-references-list {
}
.guides-references-list-item {
}
.guides-modal-row {
}
.guides-modal-row span {
  display: block;
  margin-bottom: 5px;
}
</style>
